import React from 'react';
import Table from '../../components/common/Table';
import { MemberIdTypeDTO } from '../../services/apiClient';
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime';
import { renderBooleanBadge } from '../../utils/displayUtils';

interface MemberIdTypeTableProps {
  data: MemberIdTypeDTO[];
  handleEdit: (row: MemberIdTypeDTO) => void;
  handleDelete: (row: MemberIdTypeDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const MemberIdTypeTable: React.FC<MemberIdTypeTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
        {
          label: 'Title',
          key: 'title',
        },

        {
          label: 'Position',
          key: 'displayPosition',
        },

        {
          label: 'Active',
          key: 'isActive',
          render: (row: MemberIdTypeDTO) =>
            renderBooleanBadge(row.isActive ?? false),
        },

        {
          label: 'Added',
          key: 'createdUtc',
          format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
        },
      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default MemberIdTypeTable;
